export const TRANSLATIONS_FR_DASHBOARD_AND_KNOWLEDGE = {
  "dashboard.title": "Tableau de bord",
  "dashboard.documents": "Documents",
  "dashboard.credits": "Crédits",
  "dashboard.users": "Utilisateurs actifs",
  "dashboard.questions": "Questions",
  "dashboard.embeddings": "Embeddings",
  "dashboard.status": "Statut du système",
  "dashboard.widget.plan_usage": "Utilisation du plan",
  "dashboard.widget.csv_stats": "Statistiques CSV",
  "dashboard.widget.csv_stats.uploaded": "Fichiers CSV téléversés",
  "dashboard.widget.csv_stats.queries": "Requêtes exécutées",
  "dashboard.widget.documents_stats": "Statistiques des documents",
  "dashboard.widget.documents_stats.count": "Documents téléversés",
  "dashboard.widget.documents_stats.duplicates": "Doublons",
  "dashboard.widget.documents_stats.this_month": "Ce mois-ci",
  "dashboard.widget.email_stats": "Statistiques des e-mails",
  "dashboard.widget.email_stats.sent": "E-mails traités",
  "dashboard.widget.email_stats.received": "E-mails convertis en tâches",
  "dashboard.widget.tokens_breakdown": "Répartition des tokens",
  "dashboard.widget.tokens_breakdown.input": "Tokens utilisés (embeddings)",
  "dashboard.widget.tokens_breakdown.output": "Tokens utilisés (RAG)",
  "dashboard.widget.tokens_breakdown.exceeded": "Limite de tokens dépassée",
  "dashboard.widget.rag_queries": "Requêtes RAG",
  "dashboard.widget.rag_queries.count": "Requêtes RAG",
  "dashboard.widget.rag_queries.top_users": "Meilleurs utilisateurs :",
  "dashboard.widget.plan_usage.used": "Utilisés",
  "dashboard.widget.plan_usage.remaining": "Restants",
  "dashboard.widget.plan_usage.total": "Total",
  "dashboard.widget.plan_usage.exceeded": "Limite du plan dépassée",
  "dashboard.widget.user_activity": "Activité des utilisateurs",
  "dashboard.widget.inactive_users": "Utilisateurs inactifs",
  "dashboard.widget.user_activity.active": "Utilisateurs actifs",
  "dashboard.widget.user_activity.inactive": "Utilisateurs inactifs",
  "dashboard.widget.inactive_users.count": "Utilisateurs inactifs",
  "dashboard.loading": "Chargement...",
  "dashboard.context_menu.add_widget": "Ajouter un widget",
  "dashboard.context_menu.remove_widget": "Retirer le widget",
  "dashboard.context_menu.title": "Widgets disponibles",
  "dashboard.context_menu.group.others": "Autres",
  "dashboard.context_menu.widget.csv": "CSV",
  "dashboard.context_menu.widget.consultas_rag": "Requêtes RAG",
  "dashboard.context_menu.widget.tokens": "Tokens",
  "dashboard.context_menu.widget.emails": "E-mails",
  "dashboard.context_menu.widget.documentos": "Documents",
  "dashboard.context_menu.widget.usuarios_inactivos": "Utilisateurs inactifs",
  "dashboard.empty":
    "Cliquez droit pour ajouter des widgets au tableau de bord.",
  "dashboard.widget.title.plan_usage": "Utilisation du plan",
  "dashboard.widget.title.csv_stats": "Statistiques CSV",
  "dashboard.widget.title.documents_stats": "Statistiques des documents",
  "dashboard.widget.title.email_stats": "Statistiques des e-mails",
  "dashboard.widget.title.tokens_breakdown": "Répartition des tokens",
  "dashboard.widget.title.rag_queries": "Requêtes RAG",
  "dashboard.widget.title.user_activity": "Activité des utilisateurs",
  "dashboard.widget.title.inactive_users": "Utilisateurs inactifs",
  "dashboard.context_menu.widget.plan_usage": "Utilisation du plan",
  "dashboard.context_menu.widget.csv_stats": "Statistiques CSV",
  "dashboard.context_menu.widget.documents_stats": "Statistiques des documents",
  "dashboard.context_menu.widget.email_stats": "Statistiques des e-mails",
  "dashboard.context_menu.widget.tokens_breakdown": "Répartition des tokens",
  "dashboard.context_menu.widget.rag_queries": "Requêtes RAG",
  "dashboard.context_menu.widget.user_activity": "Activité des utilisateurs",
  "dashboard.context_menu.widget.inactive_users": "Utilisateurs inactifs",
  "dashboard.widget.user_activity.last_active": "Dernière activité",
  "dashboard.widget.user_activity.user": "Utilisateur",
  "dashboard.active_users_this_month": "Utilisateurs actifs ce mois-ci :",
  "dashboard.active_users_today": "Utilisateurs actifs aujourd'hui",
  "dashboard.name": "Nom",
  "dashboard.last_login": "Dernière connexion",
  "dashboard.last_activity": "Dernière activité",
  "dashboard.inactive_users_this_month": "Utilisateurs inactifs ce mois-ci :",
  "dashboard.days_without_activity": "jours sans activité",
  "dashboard.no_inactive_users": "Aucun utilisateur inactif ce mois-ci.",
  "dashboard.questions_today": "Questions aujourd'hui",
  "dashboard.system_status": "État du système",
  "dashboard.action": "Action",
  "dashboard.context_menu.no_widgets": "Aucun widget à ajouter",
  "changes.title": "Modifications entre versions",
  "changes.empty": "Aucune modification detectee.",
  "changes.filter.allSeverities": "Toutes les severites",
  "changes.filter.allStatuses": "Tous les statuts",
  "changes.general.loading": "Chargement...",
  "changes.general.retry": "Reessayer",
  "changes.error.message": "Impossible de charger les modifications.",
  "changes.evidence.before": "Avant",
  "changes.evidence.after": "Apres",
  "changes.action.confirm": "Confirmer",
  "changes.action.needsReview": "A revoir",
  "changes.action.dismiss": "Rejeter",
  "changes.action.dismissReason": "Motif (optionnel)",
  "changes.severity.informational": "informatif",
  "changes.severity.low": "faible",
  "changes.severity.medium": "moyen",
  "changes.severity.high": "eleve",
  "changes.severity.critical": "critique",
  "changes.status.detected": "detecte",
  "changes.status.needs_review": "a revoir",
  "changes.status.confirmed": "confirme",
  "changes.status.dismissed": "rejete",
  "changes.status.superseded": "remplace",
  "changes.category.legal": "juridique",
  "changes.category.financial": "financier",
  "changes.category.operational": "operationnel",
  "changes.category.compliance": "conformite",
  "changes.category.commercial": "commercial",
  "changes.category.technical": "technique",
  "changes.category.human_resources": "RH",
  "changes.category.security": "securite",
  "changes.category.general": "general",
  "alerts.title": "Alertes de connaissances",
  "alerts.empty": "Aucune alerte active.",
  "alerts.filter.allSeverities": "Toutes les severites",
  "alerts.filter.allStatuses": "Tous les statuts",
  "alerts.filter.allSources": "Toutes les sources",
  "alerts.general.loading": "Chargement...",
  "alerts.general.retry": "Reessayer",
  "alerts.error.message": "Impossible de charger les alertes.",
  "alerts.severity.informational": "informatif",
  "alerts.severity.low": "faible",
  "alerts.severity.medium": "moyen",
  "alerts.severity.high": "eleve",
  "alerts.severity.critical": "critique",
  "alerts.status.detected": "detectee",
  "alerts.status.acknowledged": "prise en compte",
  "alerts.status.snoozed": "reportee",
  "alerts.status.resolved": "resolue",
  "alerts.status.dismissed": "rejetee",
  "alerts.status.expired": "expiree",
  "alerts.source.expiration": "echeance",
  "alerts.source.change": "modification",
  "alerts.refs.title": "References d'origine",
  "alerts.refs.open": "Ouvrir l'origine",
  "alerts.action.acknowledge": "Prendre en compte",
  "alerts.action.snooze": "Reporter",
  "alerts.action.snoozeDays": "Jours",
  "alerts.action.resolve": "Resoudre",
  "alerts.action.dismiss": "Rejeter",
  "alerts.action.dismissReason": "Motif (facultatif)",
  "alerts.action.openSource": "Voir l'origine",
  "dashboard.knowledge.title": "Tableau de bord des connaissances",
  "dashboard.knowledge.loading": "Chargement...",
  "dashboard.knowledge.error": "Impossible de charger le tableau de bord.",
  "dashboard.knowledge.retry": "Reessayer",
  "dashboard.knowledge.placeholder": "Aucune donnee pour le moment.",
  "dashboard.knowledge.changesBySeverity": "Modifications par severite",
  "dashboard.knowledge.changesByCategory": "Modifications par categorie",
  "dashboard.knowledge.expirationsByHorizon": "Echeances par horizon",
  "dashboard.knowledge.alertsByStatus": "Alertes par statut",
  "knowledge.title": "Connaissances",
  "knowledge.tabs.entities": "Entités",
  "knowledge.tabs.expirations": "Échéances",
  "knowledge.loading": "Chargement…",
  "knowledge.retry": "Réessayer",
  "knowledge.entities.subtitle": "Entités détectées dans vos documents.",
  "knowledge.entities.searchPlaceholder": "Rechercher par nom ou alias…",
  "knowledge.entities.search": "Rechercher",
  "knowledge.entities.sources": "Sources",
  "knowledge.entities.empty": "Aucune entité à afficher.",
  "knowledge.entities.error": "Impossible de charger les entités.",
  "knowledge.timeline.title": "Chronologie",
  "knowledge.timeline.empty": "Aucun événement lisible pour cette entité.",
  "knowledge.timeline.error": "Impossible de charger la chronologie.",
  "knowledge.expirations.subtitle": "Prochaines échéances détectées avec preuve.",
  "knowledge.expirations.evidence": "Preuve",
  "knowledge.expirations.dismiss": "Ignorer",
  "knowledge.expirations.dismissed": "Échéance ignorée.",
  "knowledge.expirations.dismissError": "Impossible d'ignorer l'échéance.",
  "knowledge.expirations.empty": "Aucune échéance à venir.",
  "knowledge.expirations.error": "Impossible de charger les échéances.",
  "knowledge.type.cliente": "Client",
  "knowledge.type.proveedor": "Fournisseur",
  "knowledge.type.contrato": "Contrat",
  "knowledge.type.politica": "Politique",
  "knowledge.type.area": "Département",
  "knowledge.type.riesgo": "Risque",
};
